import { IconArrowUp } from '@tabler/icons-preact';
import { useCallback, useEffect, useState } from 'preact/hooks';

import css from './PageScrollToTop.module.css';

export const PageScrollToTop = () => {
  const [visible, setVisible] = useState(false);

  const onClick = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  useEffect(() => {
    let timeout: number | undefined;

    const onScroll = () => {
      if (timeout != null) return;

      timeout = setTimeout(() => {
        timeout = undefined;
        setVisible(window.scrollY > 96);
      }, 100);
    };

    window.addEventListener('scroll', onScroll);

    return () => {
      clearTimeout(timeout);
      timeout = undefined;
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    visible && (
      <button class={css.button} onClick={onClick}>
        <IconArrowUp />
        <span>Scroll to the top</span>
      </button>
    )
  );
};
